import AuthenticationForm from '../forms/AuthenticationForm';

const HomePage: React.FC = () => {
  return (
    <div>
      <AuthenticationForm />
    </div>
  );
};

export default HomePage;
